import { Store } from "vuex";
import {
  SpaceUserInterface,
  SpaceUserTechnicalInfoRequestedInterface,
  SpaceUserTechnicalInfoReceivedInterface,
} from "@/resources/interfaces/spaceUserInterfaces";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { CANCELLATION_TIME } from "@/resources/mixins/loader/loader";
import { i18n } from "@/resources/locales";

export default class SpaceUserSocketHandler {
  /**
   * SPACE_USER_PERMISSIONS_CHANGED
   * */
  static async spaceUserPermissionsChanged(
    store?: Store<any>,
    data?,
    startLoader?: any,
    setLoaderText?: any
  ): Promise<void> {
    const { userList, userDraw } = data;
    if (userDraw) {
      await store.dispatch("GraphicClientStore/updateUser", userDraw);
      await store.dispatch("SpaceStore/updateUsersInDrawAction", userDraw);
      const user = store.getters["UserStore/getSpaceUser"];
      if (user.id === userDraw.id) {
        const isWebinar = store.getters["MeetingStore/getMeetingType"];
        const space = store.getters["SpaceStore/getSpace"];
        if (
          MEETING_TYPE.WEBINAR === isWebinar &&
          (!space.superSpace.isMultiWebinarActivated
            ? user.isWebinarHost !== userDraw.isWebinarHost
            : user.superSpaceUser.isWebinarHost !==
              userDraw.superSpaceUser.isWebinarHost)
        ) {
          /* desconectar y reconectar a la llamada*/
          await store?.dispatch("SidebarStore/setOpenCall", false);
          await store?.dispatch("ChatStore/setMinimizeChatAction", false);
          /*await this.startLoader(store, CANCELLATION_TIME.CANCEL_CALL_30);
        this.setLoaderText(store, i18n.t("loader.connectingRoom").toString());
        */
          const roomId = store.getters["MeetingStore/getRoomId"];
          setLoaderText(store, i18n.t("loader.connectingRoom").toString());
          store?.dispatch("SpaceStore/getRoomAction", {
            roomId: roomId,
            callback: (data) => {
              if (!data.hasPin) {
                startLoader(store, CANCELLATION_TIME.CANCEL_CALL_30);
                store?.dispatch("MeetingStore/joinMeetingAction", {
                  roomId,
                  callback: async (response) => {
                    if (!response.data.attendee && !response.data.meeting)
                      return;
                    await store?.dispatch(
                      "MeetingStore/setMeetingDataAction",
                      response.data
                    );
                    store?.dispatch(
                      "MeetingStore/setIsVideoUrlLockedByAdminAction",
                      response.data.isVideoUrlLockedByAdmin
                    );
                    await store?.dispatch("SidebarStore/setOpenCall", true);
                    await store?.dispatch(
                      "ChatStore/setMinimizeChatAction",
                      !store?.getters["UserStore/getConfig"].chat
                        .openRoomChatByDefault
                    );
                    setTimeout(() => {
                      store?.dispatch(
                        "GraphicClientStore/resizeGraphicClientAction"
                      );
                    }, 20);
                  },
                });
              } else {
                store?.dispatch("MeetingStore/setRoomIdAction", roomId);
                store?.dispatch("SystemStore/setShowPinRoomModalAction", true);
                store?.dispatch("SystemStore/setIsChangePinAction", false);
              }
            },
            callbackError: (err) => {
              // do nothing
            },
          });
          //location.reload();
        }
        await store.dispatch("UserStore/setSpaceUserLocal", userDraw);
      }
    }

    const allUsers = store.getters["SpaceStore/getAllUsers"].length;
    if (allUsers > 0) {
      await store.dispatch("SpaceStore/updateAllUsers", userDraw);
    }
  }
  /**
   * SPACE_USER_DISABLED
   * */
  static async spaceUserDisabled(
    store?: Store<any>,
    data?: SpaceUserInterface | null
  ): Promise<void> {
    // do nothing
  }
  /**
   * SPACE_USER_DELETED
   * */
  static async spaceUserDelete(
    store?: Store<any>,
    data?: SpaceUserInterface | null
  ): Promise<void> {
    const user = store.getters["UserStore/getSpaceUser"];
    if (user.id === data.id) {
      localStorage.setItem("city", "ON");
      localStorage.removeItem("space_default");
      window.location.reload();
    }
    const allUsers = store.getters["SpaceStore/getAllUsers"];
    if (allUsers.length > 0) {
      allUsers.splice(
        allUsers.findIndex((a) => a.id === data.id),
        1
      );
      await store.dispatch("SpaceStore/setAllUsersAction", allUsers);
    }
  }
  /**
   * SUPER_SPACE_USER_DELETED
   */
  static async superSpaceUserDeleted(store?: Store<any>, data?): Promise<void> {
    const user = store.getters["UserStore/getSpaceUser"];
    const { userList, userDraw } = data;
    if (user.superSpaceUser.user.id === userList.user.id) {
      localStorage.setItem("city", "ON");
      localStorage.removeItem("space_default");
      window.location.reload();
    }
    if (userList) {
      await store.dispatch("SpaceStore/removeUserInSpace", userList);
    }
  }
  /**
   * SPACE_USER_REQUEST_TECHNICAL_INFO
   */
  static async spaceUserTechnicalInfoRequested(
    store?: Store<any>,
    data?: SpaceUserTechnicalInfoRequestedInterface | null
  ): Promise<void> {
    const user = store.getters["UserStore/getSpaceUser"];
    const usersInSpace = store.getters["SpaceStore/getUsersInDraw"];
    const requestedFromSpaceUser = usersInSpace.find(
      (user) => user.id === data.requestedFromSpaceUser
    );

    //TODO: Mejor Error handling
    if (!requestedFromSpaceUser)
      throw new Error("requestedFromSpaceUser Not Found");

    const graphicClientDebugInfo = window["getGraphicClientDebugInfo"]();
    const technicalInfo = {
      graphicClientDebugInfo: graphicClientDebugInfo,
      frontVersion: process.env.VUE_APP_VERSION,
      frontAppDateCompilation: process.env.VUE_APP_DATE_COMPILATION,
      timeZone: user.superSpaceUser.user.timezone,
      browserInfo: navigator.userAgent,
    };

    await store.dispatch("UserStore/sendSpaceUserTechnicalInfoAction", {
      requestedFromSpaceUser: requestedFromSpaceUser.id,
      technicalInfo: technicalInfo,
      callback: (response) => {
        // do nothing
      },
      callbackError: (error) => {
        // do nothing
      },
    });
  }
  /**
   * SPACE_USER_TECHNICAL_INFO_RECEIVED
   */
  static async spaceUserTechnicalInfoReceived(
    store?: Store<any>,
    data?: SpaceUserTechnicalInfoReceivedInterface | null
  ): Promise<void> {
    await store.dispatch(
      "SystemStore/setSpaceUserTechnicalInfoReceivedAction",
      data
    );
  }
}
